import Banner from "../components/Banner";
import StatsSection from "../components/StatsSection";
import Services from "../components/Services";
import Why from "../components/Why";
import Products from "../components/Products";
import Industries from "../components/Industries";
import Process from "../components/Process";
import Testimonial from "../components/Testimonial";
import Cta from "../components/Cta";

function Home() {
  return (
    <div>
      {
		<>						
		{/* ***** Banner Area Start ***** */}
		<Banner />
		{/* ***** Banner Area END ***** */}
		
		{/* ***** Stats Area Start ***** */}
		<StatsSection />
		{/* ***** Stats Area End ***** */}
		
		{/* ***** Services Area Start ***** */}
		<Services />
		{/* ***** Services Area END ***** */}
		
		{/* ***** Why Area Start ***** */}
		<Why />
		{/* ***** Why Area END ***** */}
		
		{/* ***** Products Area Start ***** */}
		<Products />	
		{/* ***** Products Area END ***** */}
		
		{/* ***** Industries Area Start ***** */}
		<Industries />
		{/* ***** Industries Area END ***** */}
		
		{/* ***** Process Area Start ***** */}
		<Process />
		{/* ***** Process Area END ***** */}
		
		{/* ***** Testimonials Area Start ***** */}
		<Testimonial />
		{/* ***** Testimonials Area END ***** */}
		
		{/* ***** CTA Area Start ***** */}
		<Cta />
		{/* ***** CTA Area END ***** */}
		</>
	  }
    </div>
  );
}

export default Home;